import React, { useState, useCallback, useEffect } from 'react';
import { Box, Typography, Chip } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { TableKit } from '@NP-Webber/crm-kit';
import api from '../../services/api.js';
import AdminPageHeader from '../../next/AdminPageHeader.jsx';

const COLUMNS = [
  { key: 'memberId', title: 'חבר', sortable: false, render: (v) => v ? `${v.firstName} ${v.lastName}` : '—' },
  {
    key: 'type', title: 'סוג', sortable: false, filterable: true,
    render: (v) => ({ newDrasha: 'דרשה חדשה', newExam: 'מבחן חדש', gradeReady: 'ציון מוכן' }[v] || v),
  },
  {
    key: 'channel', title: 'ערוץ', sortable: false,
    render: (v) => (
      <Chip
        icon={v === 'ivr' ? <PhoneIcon sx={{ fontSize: 16 }} /> : <SmsOutlinedIcon sx={{ fontSize: 16 }} />}
        label={v === 'ivr' ? 'IVR' : 'SMS'}
        size="small"
        variant="outlined"
        sx={{ borderColor: 'var(--ck-primary-line, #90caf9)', color: 'var(--ck-primary, #1565c0)' }}
      />
    ),
  },
  {
    key: 'active', title: 'פעיל', sortable: false,
    render: (v) => v
      ? <CheckCircleIcon sx={{ color: 'var(--ck-primary, #1565c0)', fontSize: 20 }} />
      : <CancelIcon sx={{ color: 'var(--ck-text-3, #bdbdbd)', fontSize: 20 }} />,
  },
];

const Subscriptions = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/subscriptions');
      setData(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Initial fetch
  useEffect(() => { fetchData(); }, [fetchData]);

  return (
    <Box>
      <AdminPageHeader
        title="מנויים"
        sub={!loading ? `${data.length.toLocaleString('he-IL')} מנויים` : undefined}
        legacy={<Typography variant="h5" fontWeight={700} gutterBottom>מנויים</Typography>}
      />
      <TableKit
        columns={COLUMNS}
        data={data}
        total={data.length}
        loading={loading}
        clientSideMode
        emptyMessage="אין מנויים"
        exportFileName="מנויים"
      />
    </Box>
  );
};

export default Subscriptions;
